// extracted by mini-css-extract-plugin
export default {"line_table_link":"styles_line_table_link__Fx9HP","navigate_table":"styles_navigate_table__U38rs","search_block":"styles_search_block__qp+Rv"};